"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PeakAuthClient_1 = __importStar(require("./PeakAuthClient"));
const PeakAuthConstants_1 = __importDefault(require("../utilities/PeakAuthConstants"));
class PeakAuthUsersClient {
    constructor(client = new PeakAuthClient_1.default()) {
        this.client = client;
        this.endpoint = "api/:version/tenant/:tenant/users";
        this.detailedEndpoint = `${this.endpoint}/detailed`;
        this.bulkEndpoint = `${this.endpoint}/bulk`;
        this.endpointWithId = `${this.endpoint}/:id`;
        this.updateProfileImageEndpoint = `${this.endpointWithId}/images/profile`;
        this.changePasswordEndpoint = `${this.endpointWithId}/password`;
        this.operationEndpoint = `${this.endpointWithId}/:operation`;
        this.groupsEndpoint = `${this.endpointWithId}/groups`;
        this.usersServicesEndpoint = `${this.endpoint}/services`;
        this.userServicesEndpoint = `${this.endpointWithId}/services`;
        this.importEndpoint = `${this.endpoint}/import`;
        this.bulkImportEndpoint = `${this.importEndpoint}/bulk`;
        this.teamOperation = "team";
        this.managerOperation = "manager";
        this.activateOperation = "activate";
        this.deactivateOperation = "deactivate";
        this.inviteOperation = "invite";
        this.version1 = "v1";
        this.version2 = "v2";
    }
    getAsync(fetchFromExternalSources = false, includeDeactivated = false, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.getAsync({
                path: this.endpoint,
                queryStrings: { fetchFromExternalSources, includeDeactivated },
                namedQueries: { version: this.version2, tenant }
            });
        });
    }
    get(fetchFromExternalSources = false, includeDeactivated = false, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.getAsync(fetchFromExternalSources, includeDeactivated, tenant));
    }
    getDetailedAsync(fetchFromExternalSources = false, includeDeactivated = false, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.getAsync({
                path: this.detailedEndpoint,
                queryStrings: { fetchFromExternalSources, includeDeactivated },
                namedQueries: { version: this.version2, tenant }
            });
        });
    }
    getDetailed(fetchFromExternalSources = false, includeDeactivated = false, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.getDetailedAsync(fetchFromExternalSources, includeDeactivated, tenant));
    }
    getByIdAsync(id, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.getAsync({
                path: this.endpointWithId,
                namedQueries: { version: this.version1, tenant, id }
            });
        });
    }
    getById(id, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.getByIdAsync(id, tenant));
    }
    getGroups(id, tenant = PeakAuthConstants_1.default.currentTenantMoniker) { return PeakAuthClient_1.asapScheduled(this.getGroupsAsync(id, tenant)); }
    getGroupsAsync(id, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.getAsync({
                path: this.groupsEndpoint,
                namedQueries: { version: this.version1, tenant, id }
            });
        });
    }
    getMyGroups() { return PeakAuthClient_1.asapScheduled(this.getMyGroupsAsync()); }
    getMyGroupsAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.getGroupsAsync(PeakAuthConstants_1.default.currentUserMoniker);
        });
    }
    getMeAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.getByIdAsync(PeakAuthConstants_1.default.currentUserMoniker);
        });
    }
    getMe() {
        return PeakAuthClient_1.asapScheduled(this.getMeAsync());
    }
    inviteAsync(id, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.getAsync({
                path: this.operationEndpoint,
                namedQueries: { version: this.version1, tenant, id, operation: this.inviteOperation }
            });
        });
    }
    invite(id, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.inviteAsync(id, tenant));
    }
    importAsync(source, identifier, notify = true, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.postAsync({
                path: this.importEndpoint,
                namedQueries: { version: this.version2, tenant },
                queryStrings: { source, identifier, notify }
            });
        });
    }
    import(source, identifier, notify = true, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.importAsync(source, identifier, notify, tenant));
    }
    bulkImportAsync(source, identifiers, notify = true, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.postAsync({
                path: this.bulkImportEndpoint,
                namedQueries: { version: this.version2, tenant },
                queryStrings: { source, notify },
                body: identifiers
            });
        });
    }
    bulkImport(source, identifiers, notify = true, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.bulkImportAsync(source, identifiers, notify, tenant));
    }
    getBulkServicesAsync(model, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.postAsync({
                path: this.usersServicesEndpoint,
                namedQueries: { version: this.version1, tenant },
                body: model
            });
        });
    }
    getBulkServices(model, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.getBulkServicesAsync(model, tenant));
    }
    updateBulkServicesAsync(model, notify = true, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.putAsync({
                path: this.usersServicesEndpoint,
                namedQueries: { version: this.version1, tenant },
                queryStrings: { notify },
                body: model
            });
        });
    }
    updateBulkServices(model, notify = true, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.updateBulkServicesAsync(model, notify, tenant));
    }
    getServicesAsync(id, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.getAsync({
                path: this.userServicesEndpoint,
                namedQueries: { version: this.version1, tenant, id },
            });
        });
    }
    getServices(id, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.getServicesAsync(id, tenant));
    }
    updateServicesAsync(id, model, notify = true, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.putAsync({
                path: this.userServicesEndpoint,
                namedQueries: { version: this.version1, tenant, id },
                queryStrings: { notify },
                body: model
            });
        });
    }
    updateServices(id, model, notify = true, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.updateServicesAsync(id, model, notify, tenant));
    }
    postAsync(model, notify = true, resetPasswordOnNextLogon = true, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.postAsync({
                path: this.endpoint,
                body: model,
                namedQueries: { version: this.version1, tenant },
                queryStrings: { notify, resetPasswordOnNextLogon }
            });
        });
    }
    post(model, notify = true, resetPasswordOnNextLogon = true, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.postAsync(model, notify, resetPasswordOnNextLogon, tenant));
    }
    putAsync(id, model, notify = true, resetPasswordOnNextLogon = true, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.putAsync({
                path: this.endpointWithId,
                namedQueries: { version: this.version1, tenant, id },
                queryStrings: { notify, resetPasswordOnNextLogon },
                body: model
            });
        });
    }
    put(id, model, notify = true, resetPasswordOnNextLogon = true, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.putAsync(id, model, notify, resetPasswordOnNextLogon, tenant));
    }
    updateBulkAsync(model, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.putAsync({
                path: this.bulkEndpoint,
                namedQueries: { version: this.version1, tenant },
                body: model
            });
        });
    }
    updateBulk(model, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.updateBulkAsync(model, tenant));
    }
    updateProfileImageAsync(id, file, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append("file", file);
            return yield this.client.putAsync({
                path: this.updateProfileImageEndpoint,
                namedQueries: { version: this.version1, tenant, id },
                body: formData,
                headers: { 'Content-Type': 'multipart/form-data' }
            });
        });
    }
    updateProfileImage(id, file, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.updateProfileImageAsync(id, file, tenant));
    }
    removeProfileImageAsync(id, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.deleteAsync({
                path: this.updateProfileImageEndpoint,
                namedQueries: { version: this.version1, tenant, id }
            });
        });
    }
    removeProfileImage(id, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.removeProfileImageAsync(id, tenant));
    }
    changePasswordAsync(id, password, notify = true, resetPasswordOnNextLogon = false, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.putAsync({
                path: this.changePasswordEndpoint,
                namedQueries: { version: this.version1, tenant, id },
                queryStrings: { password, notify, resetPasswordOnNextLogon }
            });
        });
    }
    changePassword(id, password, notify = true, resetPasswordOnNextLogon = true, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.changePasswordAsync(id, password, notify, resetPasswordOnNextLogon, tenant));
    }
    putMeAsync(model, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.putAsync(PeakAuthConstants_1.default.currentUserMoniker, model, false, false, tenant);
        });
    }
    putMe(model, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.putMeAsync(model, tenant));
    }
    deleteAsync(id, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.client.deleteAsync({
                path: this.endpointWithId,
                namedQueries: { version: this.version1, tenant, id }
            });
        });
    }
    delete(id, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.deleteAsync(id, tenant));
    }
    deleteBulkAsync(ids, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.client.deleteAsync({
                path: this.bulkEndpoint,
                namedQueries: { version: this.version1, tenant },
                body: ids
            });
        });
    }
    deleteBulk(ids, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.deleteBulkAsync(ids, tenant));
    }
    getTeamAsync(id, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.getAsync({
                path: this.operationEndpoint,
                namedQueries: { version: this.version1, tenant, id, operation: this.teamOperation }
            });
        });
    }
    getTeam(id, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.getTeamAsync(id, tenant));
    }
    getMyTeamAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.getTeamAsync(PeakAuthConstants_1.default.currentUserMoniker);
        });
    }
    getMyTeam() {
        return PeakAuthClient_1.asapScheduled(this.getMyTeamAsync());
    }
    getManagerAsync(id, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.getAsync({
                path: this.operationEndpoint,
                namedQueries: { version: this.version1, tenant, id, operation: this.managerOperation }
            });
        });
    }
    getManager(id, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.getManagerAsync(id, tenant));
    }
    getMyManagerAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.getManagerAsync(PeakAuthConstants_1.default.currentUserMoniker);
        });
    }
    getMyManager() {
        return PeakAuthClient_1.asapScheduled(this.getMyManagerAsync());
    }
    putManagerAsync(id, model, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.putAsync({
                path: this.operationEndpoint,
                namedQueries: { version: this.version1, tenant, id, operation: this.managerOperation },
                body: model
            });
        });
    }
    putManager(id, model, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.putManagerAsync(id, model, tenant));
    }
    deleteManagerAsync(id, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.client.deleteAsync({
                path: this.operationEndpoint,
                namedQueries: { version: this.version1, tenant, id, operation: this.managerOperation }
            });
        });
    }
    deleteManager(id, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.deleteManagerAsync(id, tenant));
    }
    activateAsync(id, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.client.putAsync({
                path: this.operationEndpoint,
                namedQueries: { version: this.version1, tenant, id, operation: this.activateOperation }
            });
        });
    }
    activate(id, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.activateAsync(id, tenant));
    }
    deactivateAsync(id, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.client.putAsync({
                path: this.operationEndpoint,
                namedQueries: { version: this.version1, tenant, id, operation: this.deactivateOperation }
            });
        });
    }
    deactivate(id, tenant = PeakAuthConstants_1.default.currentTenantMoniker) {
        return PeakAuthClient_1.asapScheduled(this.deactivateAsync(id, tenant));
    }
}
exports.default = PeakAuthUsersClient;
